/// <reference path="viewmodels/masterviewmodel.ts" />

module Tapas {
    export class Util {

        public static back = () => {
            window.history.back();
        }
    }
}